module.exports = __webpack_public_path__ + "zoom3.svg";